import { useSelector } from 'react-redux';
import RootState from '../../types';

const selector = (state: RootState) => state.isWebView.webView ? '' : '_blank';

const useLinkTarget = () => {
    return useSelector(selector);
}

export default useLinkTarget;